<template>
	<div class="ao-tags-wrapper">
		<div
			v-if="label"
			class="ao-text-600 ao-p2-regular mb-3"
		>
			{{ label }}
		</div>
		<div class="list d-flex flex-wrap">
			<div
				v-for="item in items"
				class="tag ao-p2-regular"
			>
				{{ item?.[itemTitle] }}
				<ao-icon
					class="ml-1 cursor-pointer"
					iconName="closeCircle"
					@click="$emit('delete', handleDelete(item))"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AoTags',
	props: {
		label: String,
		items: {
			type: Array,
			default: () => [],
		},
		itemTitle: {
			type: String,
			default: 'title',
		},
		itemValue: {
			type: String,
			default: 'key',
		},
		returnObject: Boolean,
	},

	methods: {
		handleDelete(item) {
			const returnItem = this.returnObject ? item : item[this.itemValue]

			this.$emit('delete', returnItem)
		}
	}
}
</script>

<style scoped lang="scss">
.ao-tags-wrapper {
	.list {
		gap: 8px;
	}

	.tag {
		display: flex;
		align-items: center;
		padding: 4px 4px 4px 8px;

		background: #f0f4f7;
		border-radius: 2px;
	}
}
</style>